import { registerBulkAction } from '@vendure/admin-ui/core';
import { productListBulkAction, customerListBulkAction } from './bulk-actions';

export default [
    registerBulkAction(productListBulkAction),
    registerBulkAction(customerListBulkAction),
];
